import { useEffect } from 'react';
import { sendStartEvents } from "../../lib/rio/rioEvents";
export function useSendStartEvents(view) {
  useEffect(function () {
    sendStartEvents(view);
  }, [view]);
}